import styled, { css, keyframes } from 'styled-components/macro'
import { mq } from 'styles/mq'

const pulsingLeft = keyframes`
0%{
    transform: translateX(0px)
}
100%{
    transform: translateX(5px)
    }
`
const pulsingRight = keyframes`
0%{
    transform: translateX(0px) rotate(180deg);
}
100%{
    transform: translateX(-5px) rotate(180deg);
    }
`
export const BottomNavContainer = styled.div`
  position: relative;
  height: 98px;
  width: 100%;
  margin: auto;
  //margin-top: calc(0px - var(--spacing-lg));
  margin-bottom: var(--spacing-lg);
  max-width: calc(60rem + 4 * var(--spacing-sm));
  padding: 0 var(--spacing-sm);
  ${mq.smallOnly} {
    max-width: calc(60rem + 2 * var(--spacing-sm));
  }
  display: flex;
  justify-content: space-between;
  ${mq.large} {
    position: absolute;
    display: block;
    /*top: 100%;*/
    margin-top: calc(0px - var(--spacing-lg));
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    max-width: none;
    padding: 0;
  }
`
const BottomNav = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse;
  top: 0;
  //transform: translateY(var(--spacing-lg));
  ${mq.large} {
    position: absolute;
    transform: translateY(-100%);
    flex-direction: row;
  }
  width: 235px;
  max-width: calc(50% - var(--spacing-sm) / 2);
  height: 100%;
  color: #ffffff;
  text-decoration: none;
  bottom: var(--spacing-sm);
  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.3);
  background-size: cover;
  background-position: center;
  overflow: hidden;
  &::before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
  }
  span {
    position: relative;
    font-size: 1.2rem;
    text-align: center;
    text-transform: uppercase;
    font-weight: 700;

    ${mq.medium} {
      font-size: 1.4rem;
    }
    ${mq.large} {
      font-size: 1.6rem;
    }
  }
`
export const BottomNavLeft = styled(BottomNav)<{ $url: string }>`
  left: 0;
  border-radius: 10px;
  ${mq.large} {
    border-radius: 0px 10px 10px 0px;
  }
  background-image: url(${(props) => props.$url});
  span {
    padding-right: 14px;
    padding-left: 4px;
  }
  &::before {
    background: linear-gradient(
      270deg,
      rgba(16, 44, 68, 0) 18.8%,
      #102c44 100%
    );
    ${mq.large} {
      background: linear-gradient(
        90deg,
        rgba(16, 44, 68, 0) 18.8%,
        #102c44 100%
      );
    }
  }
`
export const BottomNavRight = styled(BottomNav)<{ $url: string }>`
  right: 0;
  border-radius: 10px;
  ${mq.large} {
    border-radius: 10px 0px 0px 10px;
  }
  background-image: url(${(props) => props.$url});
  span {
    padding-left: 14px;
    padding-right: 4px;
  }
  &::before {
    background: linear-gradient(90deg, rgba(16, 44, 68, 0) 18.8%, #102c44 100%);
    ${mq.large} {
      background: linear-gradient(
        270deg,
        rgba(16, 44, 68, 0) 18.8%,
        #102c44 100%
      );
    }
  }
`
export const BottomNavArrow = styled.div<{ $dir: 'prev' | 'next' }>`
  position: relative;
  width: 28px;
  height: 28px;
  animation: ${pulsingLeft} 1s alternate infinite;

  background: url("data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' fill='white' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.50559 13.9999L13.5173 6.98828L15.1681 8.63795L9.80143 14.0046L15.1681 19.3713L13.5173 21.0116L6.50559 14.0011L6.50559 13.9999ZM12.8336 13.9999L19.8464 6.98828L21.4961 8.63795L16.1294 14.0046L21.4961 19.3713L19.8464 21.0116L12.8348 14.0011L12.8336 13.9999Z' /%3E%3C/svg%3E%0A")
    center center / contain no-repeat;
  ${(props) =>
    props.$dir === 'next' &&
    css`
      animation: ${pulsingRight} 1s alternate infinite;
    `}
`
